__turbopack_context__.v({
  "header": "header-module-scss-module__fg8F_q__header",
  "headerDesktop": "header-module-scss-module__fg8F_q__headerDesktop",
  "headerDesktopBottom": "header-module-scss-module__fg8F_q__headerDesktopBottom",
  "headerDesktopBottomContent": "header-module-scss-module__fg8F_q__headerDesktopBottomContent",
  "headerDesktopNavList": "header-module-scss-module__fg8F_q__headerDesktopNavList",
  "headerDesktopNavListItemLink": "header-module-scss-module__fg8F_q__headerDesktopNavListItemLink",
  "headerDesktopTop": "header-module-scss-module__fg8F_q__headerDesktopTop",
  "headerDesktopTopContent": "header-module-scss-module__fg8F_q__headerDesktopTopContent",
  "headerLink": "header-module-scss-module__fg8F_q__headerLink",
  "headerMobile": "header-module-scss-module__fg8F_q__headerMobile",
  "headerMobileContent": "header-module-scss-module__fg8F_q__headerMobileContent",
  "stickyHeader": "header-module-scss-module__fg8F_q__stickyHeader",
});
